import React from 'react';
import { FilterProps } from '../../model';
import { RadioGroupFilter } from '../RadioGroupFilter';
import { useWixPatternsContainer } from '@wix/bex-core/react';

interface CheckboxCustomFieldFilterProps extends FilterProps<unknown[]> {}

export const CheckboxCustomFieldFilter = (
  props: CheckboxCustomFieldFilterProps,
) => {
  const { translate: t } = useWixPatternsContainer();

  return (
    <RadioGroupFilter
      {...props}
      data={[
        {
          id: 'checked',
          name: t('cairo.customFields.fieldType.checkbox.Selected.checked'),
          value: true,
        },
        {
          id: 'unchecked',
          name: t('cairo.customFields.fieldType.checkbox.Selected.notChecked'),
          value: false,
        },
      ]}
    />
  );
};
